import { startRecordSession, TRACKER_NAMES, isFullStoryInitializationRequired } from '@pearsontechnology/bronte-lib-fullstory';
import ClassService from '../../services/ClassService';
import FeatureFlagService from '../../services/FeatureFlagService';

let setTrackingUserResolver;
const userPromise = new Promise((resolve) => {
  setTrackingUserResolver = resolve;
});

const TrackerCDP = {
  register: () => Promise.resolve(),
  context: () => ({ get: async () => 'LEARNER' }),
  features: () => ({ is: async (featureName) => FeatureFlagService.is(featureName) }),
  user: () => ({ get: async () => userPromise }),
  cohort: () => ({ get: async () => ClassService.build({ id: 'fullstory' }).getCohort() }),
};
export const initializeFullStory = () => {
  startRecordSession(TrackerCDP, 'learnspace', { trackers: [TRACKER_NAMES.USER_TRACKER] });
};

export const setTrackingUser = (user) => {
  setTrackingUserResolver(user);
};

export const handleFullStoryInitBasedOnCookiePreference = () => {
  const isFullStoryInitalizationEnabled = isFullStoryInitializationRequired();

  if (isFullStoryInitalizationEnabled) {
    FeatureFlagService.initializeFeatureFlags()
      .then(initializeFullStory);
  }
};
